import { render, staticRenderFns } from "./TruckTachographMeasurementFragment.vue?vue&type=template&id=20d57905&scoped=true&"
import script from "./TruckTachographMeasurementFragment.vue?vue&type=script&lang=js&"
export * from "./TruckTachographMeasurementFragment.vue?vue&type=script&lang=js&"
import style0 from "./TruckTachographMeasurementFragment.vue?vue&type=style&index=0&id=20d57905&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d57905",
  null
  
)

/* custom blocks */
import block0 from "./TruckTachographMeasurementFragment.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports